import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPageTitle } from '../../redux/title/title.slice';
import { generateNavItems } from '../../lib/menuItems';
import SectionMenu from '../../components/SectionMenu';

export default function ClientServices() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(setPageTitle('Client Services'));
  }, [dispatch]);

  const nav = generateNavItems(user);
  const section = nav.find((x) => x.title === 'Client Services');

  return <SectionMenu title={section.title} items={section.items} />;
}
